import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import Link from 'next/link';

import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import { FeatureImage } from 'src/types';
interface BlogSearchCard {
  title: string;
  slug: string;
  image: FeatureImage;
}
const BlogSearchCard = (props: BlogSearchCard) => {
  const { title, slug, image } = props;

  return (
    <Link href="/blog/[post]" as={`/blog/${slug}/`}>
      <a
        className={ivclass(
          'iv-grid iv-grid-cols-2',
          'md:iv-gap-20 sm:iv-gap-20',
          'sm:iv-flex-col',
        )}
      >
        <div
          className={ivclass(
            'iv-max-h-[135px] iv-max-w-[240px]',
            'md:iv-max-h-[190px] md:iv-max-w-[342px]',
            'sm:iv-max-h-full sm:iv-max-w-full',
            'iv-overflow-hidden',
            'iv-rounded-xl',
            'sm:iv-col-span-2',
          )}
          style={{
            backfaceVisibility: 'hidden',
            transform: 'translate3d(0,0,0)',
          }}
        >
          <ImageComponent
            elementype="imagekit"
            loading="lazy"
            src={image?.url || ''}
            className={ivclass(
              'iv-w-full iv-h-full',
              'xl:iv-h-[135px] lg:iv-h-[135px] md:iv-h-[190px] sm:iv-h-[180px]',
              'hover:iv-scale-110 iv-transition-all iv-duration-300',
              'sm:iv-w-full',
              'hover:iv-cursor-pointer',
              'iv-object-cover',
            )}
          />
        </div>
        <div
          className={ivclass(
            'iv-text-heading-2xs iv-font-bold',
            'md:iv-text-heading-3xs sm:iv-text-heading-3xs ',
            'iv-text-black-85',
            'hover:iv-cursor-pointer',
            'sm:iv-col-span-2',
          )}
        >
          {title}
        </div>
      </a>
    </Link>
  );
};

export default BlogSearchCard;
